import { render, staticRenderFns } from "./SesionDetail.vue?vue&type=template&id=45aa90ee&scoped=true&"
import script from "./SesionDetail.vue?vue&type=script&lang=js&"
export * from "./SesionDetail.vue?vue&type=script&lang=js&"
import style0 from "./SesionDetail.vue?vue&type=style&index=0&id=45aa90ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa90ee",
  null
  
)

export default component.exports